import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';

interface TempusUserGuideProps {
  markdownContent: string;
  defaultExpanded?: boolean;
}

const TempusUserGuide: React.FC<TempusUserGuideProps> = ({
  markdownContent,
  defaultExpanded = true
}) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  useEffect(() => {
    setIsExpanded(defaultExpanded);
  }, [defaultExpanded]);

  return (
    <div className="bg-white rounded-lg shadow mt-8">
      <div
        className="p-4 flex justify-between items-center cursor-pointer hover:bg-gray-50"
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <h2 className="text-xl font-semibold text-gray-800">Timely IRB User Guide</h2>
        <div className="text-gray-500">
          {isExpanded ? (
            <ChevronUpIcon className="h-6 w-6" />
          ) : (
            <ChevronDownIcon className="h-6 w-6" />
          )}
        </div>
      </div>

      {isExpanded && (
        <div className="p-6 border-t border-gray-100">
          <div className="prose max-w-none">
            <ReactMarkdown
              components={{
                // Custom component for links to open in new tab
                a: ({ node, ...props }) => {
                  const { children, ...rest } = props;
                  return (
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      {...rest}
                    >
                      {children}
                    </a>
                  );
                },
              }}
            >
              {markdownContent}
            </ReactMarkdown>
          </div>
        </div>
      )}
    </div>
  );
};

export default TempusUserGuide;
